import React, { useState } from 'react';
import {
  Paper,
  Typography,
  Divider,
  Grid,
  Box,
} from '@mui/material';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

interface Step5SimViewProps {
  data: {
    hasCertification: boolean | null;
    certificationSoldInFairs: boolean | null;
    hasMunicipalSeal: boolean | null;
    municipalSealName: string;
    wantsMunicipalSeal: boolean | null;
    knowsHowToCreateSeal: boolean | null;
    referenceYear: number;
  };
}

const booleanText = (value: boolean | null) =>
  value === true ? 'Sim' : value === false ? 'Não' : 'Não informado';

const Step5SimView: React.FC<Step5SimViewProps> = ({ data }) => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Paper elevation={1} sx={{ p: 0, mt: 2 }}>
      <Box
        sx={{ px: 3, pt: 2, cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              color: "#000000DE",
              fontSize: "20px",
              mb: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {open ? (
              <KeyboardArrowUpOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            ) : (
              <KeyboardArrowDownOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            )}
            Certificação e Selo Municipal
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
      </Box>

      {open && (
        <Box sx={{ p: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2">
                O município possui produto(s) da agricultura familiar com certificação ou identificação?
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {booleanText(data.hasCertification)}
              </Typography>
            </Grid>

            {data.hasCertification && (
              <Grid item xs={12}>
                <Typography variant="subtitle2">
                  Esses produtos com certificação ou identificação são vendidos em feiras da agricultura familiar?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {booleanText(data.certificationSoldInFairs)}
                </Typography>
              </Grid>
            )}

            {data.hasCertification && (
              <>
                <Grid item xs={12}>
                  <Typography variant="subtitle2">
                    O município possui selo próprio (municipal) para agregação de valor e/ou identificação de produtos da agricultura familiar?
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    {booleanText(data.hasMunicipalSeal)}
                  </Typography>
                </Grid>

                {data.hasMunicipalSeal && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2">
                      Nome do selo municipal:
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                      {data.municipalSealName || 'Não informado'}
                    </Typography>
                  </Grid>
                )}

                {data.hasMunicipalSeal === false && (
                  <>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        O município tem interesse em criar um selo municipal para agregação de valor e/ou{' '}
                        identificação de produtos da agricultura familiar?
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        {booleanText(data.wantsMunicipalSeal)}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        O município sabe como criar um selo municipal de agregação de valor e/ou{' '}
                        identificação de produtos da agricultura familiar?
                      </Typography>
                      <Typography variant="body1" sx={{ mb: 2 }}>
                        {booleanText(data.knowsHowToCreateSeal)}
                      </Typography>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
        </Box>
      )}
    </Paper>
  );
}

export default Step5SimView;
